import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_CONNECTOR_TYPE = createActionTypes('FETCH_CONNECTOR_TYPE');
export const GET_CONNECTOR_TYPE = createActionTypes('GET_CONNECTOR_TYPE');
export const CREATE_CONNECTOR_TYPE = createActionTypes('CREATE_CONNECTOR_TYPE');
export const UPDATE_CONNECTOR_TYPE = createActionTypes('UPDATE_CONNECTOR_TYPE');
export const DELETE_CONNECTOR_TYPE = createActionTypes('DELETE_CONNECTOR_TYPE');
